import _ from 'lodash';
import React from 'react';

import {
    Row,
} from 'antd';

import SalleFiltre from './SalleFiltre';
import ViewModeButton from '../ViewModeButton/ViewModeButton';

const SalleFiltres = (props) => {
    const {
        defaultSalles,
        onModeChange,
        onSalleSelect,
        maximumSelectedVertical,
        mode,
        modeDisabled,
        selected,
    } = props;

    const renderSalleFiltre = React.useMemo(() => (
        <Row
            align='middle'
            justify='space-around'
            style={{
                marginRight: '1rem',
            }}
        
        >
            <SalleFiltre
                defaultSalles={defaultSalles}
                selected={selected}
                onSalleSelect={onSalleSelect}
            />
        </Row>
    ), [defaultSalles, onSalleSelect, selected])

    return (
        <Row
            justify='end'
        >
            {renderSalleFiltre}
            <ViewModeButton
                onChange={onModeChange}
                mode={mode}
                maximumSelectedVertical={maximumSelectedVertical}
                disabled={modeDisabled}
            />
        </Row>
    )
};

export default SalleFiltres;